import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const CircleIcon = ({
  color,
  width = 18,
  height = 18,
  ...rest
}: {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
  [x: string]: unknown;
}) => {
  const { token } = useToken();
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M9 1.40625C7.4981 1.40625 6.02993 1.85162 4.78114 2.68603C3.53236 3.52044 2.55905 4.70642 1.98429 6.094C1.40954 7.48157 1.25916 9.00842 1.55217 10.4815C1.84517 11.9545 2.56841 13.3076 3.63041 14.3696C4.69242 15.4316 6.04549 16.1548 7.51854 16.4478C8.99158 16.7408 10.5184 16.5905 11.906 16.0157C13.2936 15.441 14.4796 14.4676 15.314 13.2189C16.1484 11.9701 16.5938 10.5019 16.5938 9C16.5915 6.9867 15.7907 5.0565 14.3671 3.63287C12.9435 2.20925 11.0133 1.40848 9 1.40625ZM9 14.9062C7.83186 14.9062 6.68994 14.5599 5.71867 13.9109C4.74739 13.2619 3.99037 12.3394 3.54334 11.2602C3.09631 10.181 2.97935 8.99345 3.20724 7.84775C3.43513 6.70205 3.99765 5.64965 4.82365 4.82365C5.64966 3.99765 6.70205 3.43513 7.84775 3.20724C8.99345 2.97934 10.181 3.09631 11.2602 3.54334C12.3395 3.99037 13.2619 4.74739 13.9109 5.71866C14.5599 6.68994 14.9063 7.83185 14.9063 9C14.9046 10.5659 14.2818 12.0672 13.1745 13.1745C12.0672 14.2818 10.5659 14.9046 9 14.9062Z"
        fill={color ?? token.colorText}
      />
    </svg>
  );
};

export default CircleIcon;
